import React from "react";

import "./index.scss";

const ZoomIcon = () => (
  <svg id="Zoom_Out" data-name="Zoom Out" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="parent-zoom">
    <defs />
    <g id="Group_15142" data-name="Group 15142">
      <path id="Margin" className="cls-1" d="M0,0H32V32H0Z" />
      <path
        id="Path_13000"
        data-name="Path 13000"
        className="cls-2"
        d="M18.687,8l2.044,2.044L18.162,12.6l1.262,1.262,2.551-2.569,2.045,2.044V8ZM13.353,24l-2.044-2.044L13.878,19.4l-1.263-1.262-2.551,2.569L8.02,18.667V24Z"
      />
    </g>
  </svg>
);

export default ZoomIcon;
